import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Stack,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';

const refunds = [
  {
    refundId: 'REF-001',
    orderId: 'ORD-001',
    customer: 'John Doe',
    amount: '$299.99',
    reason: 'Defective product',
    status: 'Pending',
    date: '2024-01-25',
  },
  {
    refundId: 'REF-002',
    orderId: 'ORD-003',
    customer: 'Mike Johnson',
    amount: '$89.99',
    reason: 'Wrong item',
    status: 'Approved',
    date: '2024-01-24',
  },
  {
    refundId: 'REF-003',
    orderId: 'ORD-002',
    customer: 'Jane Smith',
    amount: '$149.50',
    reason: 'Not satisfied',
    status: 'Rejected',
    date: '2024-01-23',
  },
];

const getStatusStyle = (status) => {
  switch (status) {
    case 'Approved':
      return { color: '#027a48', backgroundColor: '#ecfdf3' };
    case 'Pending':
      return { color: '#b54708', backgroundColor: '#fefce8' };
    case 'Rejected':
      return { color: '#b42318', backgroundColor: '#fee4e2' };
    default:
      return {};
  }
};

const RefundsManagement = () => {
  return (
    <Box p={3} component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
          <Typography variant="h5" fontWeight="bold">
            Refunds Management
          </Typography>
          <Typography color="text.secondary">
            Handle refund requests and approvals
          </Typography>
        </Box>
        <Button variant="outlined" sx={{ textTransform: 'none' }}>
          Filter by status
        </Button>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
           <TableRow sx={{ backgroundColor: '#1976d2' }}>
  {[
    'Refund ID',
    'Order ID',
    'Customer',
    'Amount',
    'Reason',
    'Status',
    'Date',
    'Actions'
  ].map((head) => (
    <TableCell
      key={head}
      sx={{ fontWeight: 'bold', color: 'white' }}
    >
      {head}
    </TableCell>
  ))}
</TableRow>

          </TableHead>
          <TableBody>
            {refunds.map((refund) => (
              <TableRow key={refund.refundId}>
                <TableCell>{refund.refundId}</TableCell>
                <TableCell>{refund.orderId}</TableCell>
                <TableCell>{refund.customer}</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>{refund.amount}</TableCell>
                <TableCell>{refund.reason}</TableCell>
                <TableCell>
                  <Box
                    component="span"
                    sx={{
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 2,
                      fontSize: 12,
                      fontWeight: 500,
                      display: 'inline-block',
                      ...getStatusStyle(refund.status),
                    }}
                  >
                    {refund.status}
                  </Box>
                </TableCell>
                <TableCell>{refund.date}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1} alignItems="center">
                    {refund.status === 'Pending' && (
                      <>
                        <IconButton
                          size="small"
                          sx={{ border: '1px solid #ccc', borderRadius: 1 }}
                        >
                          <CheckIcon fontSize="small" sx={{ color: 'green' }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          sx={{ border: '1px solid #ccc', borderRadius: 1 }}
                        >
                          <CloseIcon fontSize="small" sx={{ color: 'red' }} />
                        </IconButton>
                      </>
                    )}
                    <IconButton size="small">
                      <VisibilityIcon />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RefundsManagement;
